<template>
  <div class="inner-page analitics-balance-page">
    <header-on-slots>
      <template v-slot:menu-button>
        <button type="button" class="menu-button" @click="onCloseNavMenu">
          <span>Меню</span>
        </button>
      </template>
      <template v-slot:header-title>
        <div class="header-title">
          <div class="up-title">Аналитика</div>
          <div class="main-title">Баланс количественных характеристик</div>
        </div>
        <div class="spacer" />
      </template>
      <template v-slot:header-buttons>
        <div class="header-buttons">
          <regular-button
            v-if="!isSearchFormVisible"
            type="button"
            :icon-only="true"
            @click.stop="isSearchFormVisible = !isSearchFormVisible"
          >
            <icon name="search" />
          </regular-button>
          <search-form
            :is-visible="isSearchFormVisible"
            :get-data="searchTerm => getSearchData(searchTerm)"
            @select-suggestion="onSelectSearchSuggestion"
          />
        </div>
      </template>
    </header-on-slots>

    <main-nav-menu :is-menu-active="isNavMenuVisible" @close-menu="onCloseNavMenu" />

    <delete-info
      v-if="isActiveDeleting"
      :object-name="'запись(-и)'"
      @onCancelDeleting="onCancelDeleting"
      @closeDeleteInfo="closeDeleteInfo"
    />

    <div class="page-container">
      <div class="table-wrapper" :class="{ 'upload-data': uploadData }">
        <circle-loader v-if="uploadData" size="xlarge" :indeterminate="true" />

        <div class="table-header">
          <div class="table-header__filters">
            <form-select
              :input-model="periodFilter"
              fieldname="period"
              label="Период"
              :input-options="periodOptions"
              @update="updateFilters"
            />
            <form-checkbox-multi-select
              :value="classFilter"
              :options="classOptions"
              label="Класс опасности"
              fieldname="hazard_class"
              @change="updateFilters"
              @hide-option-menu="updateClassFilter"
            >
              <template v-slot:option-list="{ optionList, onSelectOption }">
                <ul v-if="Array.isArray(optionList) && optionList.length > 0">
                  <li v-for="(option, index) in optionList" :key="`class-filter-option-checkbox-${index}`">
                    <FormCheckbox
                      :label="option.text"
                      :checked="value.indexOf(option.value) > -1"
                      @click="onSelectOption(option)"
                    />
                  </li>
                </ul>
              </template>
            </form-checkbox-multi-select>
          </div>

          <i class="spacer" />

          <div class="table-header__buttons">
            <template v-if="isAuthorized">
              <button type="button" class="table-header__button add-button" @click="onAddNewRecord">
                Добавить
              </button>
              <button type="button" class="table-header__button export-button" @click="onExportObjects">
                Экспорт
              </button>
            </template>
            <button type="button" class="table-header__button config-button" @click.stop="toggleTableConfig" />
            <div v-if="showTableConfigs" class="table-config" @click.stop>
              <div class="table-config__head">
                <div class="head-title">Столбцы</div>
                <div class="all-button" @click="onSetChangeColumnsAll">Все</div>
                <div class="close-button" @click.stop="toggleTableConfig"></div>
              </div>
              <div class="table-config__list">
                <ul>
                  <li
                    v-for="(column, index) in columnsConfig"
                    :key="index"
                    :class="{ 'not-active': !column.isActive }"
                    @click="onChangeActiveColumnConfig(column)"
                  >
                    {{ column.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <table-breadcrumbs :nav-elements="navElements" @selected-item="id => onSelectBreadcrumbItem(id)" />

        <div class="table-body table-body__with-scroll">
          <table>
            <thead>
              <tr>
                <template v-for="column in columnsConfig">
                  <th
                    v-if="column.isActive"
                    :key="column.key"
                    :class="{
                      th__active:
                        smartFilterSelected[column.key] &&
                        initialContainerSuggestionDataOption[column.key] &&
                        smartFilterSelected[column.key].length > 1 &&
                        initialContainerSuggestionDataOption[column.key].length !== smartFilterSelected[column.key].length
                    }"
                  >
                    <div>
                      <span
                        v-if="
                          !smartFilterSelected[column.key] ||
                            smartFilterSelected[column.key].length === 0 ||
                            smartFilterSelected[column.key].length > 1
                        "
                      >
                        <span class="text">{{ column.name }}</span>
                        <span class="subname">{{ column.subname }}</span>
                        <div
                          v-if="ordering.key === column.key && ordering.type !== 'NONE'"
                          :class="ordering.type"
                          class="table-order"
                        />
                      </span>
                      <smart-filter
                        v-if="columnsForSmartFilter[column.key]"
                        :column-key="column.key"
                        :suggestions-url="suggestionsUrl"
                        :smart-filter-selected="smartFilterSelected"
                        :search-with-filters-function-name="searchWithFiltersFunctionName"
                        :columns-smart-filters-was-opened="columnsSmartFiltersWasOpened"
                        :initial-container-suggestion-data-option="initialContainerSuggestionDataOption"
                        :show-smart-filter="showSmartFilter[column.key]"
                      />
                    </div>
                  </th>
                </template>
                <th class="table-actions">
                  <span>&nbsp;</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in objectList" :key="`table-body-column-${item.fkko_id}`" :class="`tr-elem-${item.fkko_id}`">
                <template v-for="(column, rowIndex) in columnsConfig">
                  <td
                    v-if="column.isActive"
                    :key="`table-body-column-${item.fkko_id}-row-${rowIndex}`"
                    :class="{ 'has-children': item.has_children }"
                  >
                    <span v-if="column.key === 'name'" @click="onSelectTableItem(item)">{{
                      replaceIfEmpty(item.name, "-")
                    }}</span>
                    <span v-else-if="column.key === 'name'" class="subvalue">{{ replaceIfEmpty(item.code, "0") }}</span>
                    <span v-else-if="column.key === 'year_begin'">{{ replaceIfEmpty(item.year_begin, "0") }}</span>
                    <span v-else-if="column.key === 'created'">{{ replaceIfEmpty(item.created, "0") }}</span>
                    <span v-else-if="column.key === 'received'">{{ replaceIfEmpty(item.received, "0") }}</span>
                    <span v-else-if="column.key === 'processed'">
                      {{ replaceIfEmpty(item.processed, "0") }}
                      <strong>
                        ({{
                          item.processed && item.created && item.created !== 0
                            ? `${formatPercents((item.processed / item.created) * 100)}%`
                            : "0%"
                        }})
                      </strong>
                    </span>
                    <span v-else-if="column.key === 'recycled'">
                      {{ replaceIfEmpty(item.recycled, "0") }}
                      <strong>
                        ({{
                          item.recycled && item.created && item.created !== 0
                            ? `${formatPercents((item.recycled / item.created) * 100)}%`
                            : "0%"
                        }})
                      </strong>
                    </span>
                    <span v-else-if="column.key === 'neutralized'">
                      {{ replaceIfEmpty(item.neutralized, "0") }}
                      <strong>
                        ({{
                          item.neutralized && item.created && item.created !== 0
                            ? `${formatPercents((item.neutralized / item.created) * 100)}%`
                            : "0%"
                        }})
                      </strong>
                    </span>
                    <span v-else-if="column.key === 'disposed'">
                      {{ replaceIfEmpty(item.disposed, "0") }}
                      <strong>
                        ({{
                          item.disposed && item.created && item.created !== 0
                            ? `${formatPercents((item.disposed / item.created) * 100)}%`
                            : "0%"
                        }})
                      </strong>
                    </span>
                    <span v-else-if="column.key === 'stored'">{{ replaceIfEmpty(item.stored, "0") }}</span>
                    <span v-else-if="column.key === 'sended'">{{ replaceIfEmpty(item.sended, "0") }}</span>
                    <span v-else-if="column.key === 'year_end'">{{ replaceIfEmpty(item.year_end, "0") }}</span>
                    <span v-else-if="typeof item[column.key] !== 'undefined'">{{ item[column.key] }}</span>
                    <div v-else>&nbsp;</div>
                  </td>
                </template>
                <td class="table-actions">
                  <template v-if="isAuthorized">
                    <template v-if="!item.has_children">
                      <button type="button" class="edit-button" @click="onEditItem(item)" />
                      <button type="button" class="delete-button" @click="onDeleteItem(item)" />
                    </template>
                    <div v-else>&nbsp;</div>
                  </template>
                  <template v-else>
                    <div>&nbsp;</div>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <right-menu v-if="isRightMenuVisible" :is-visible="isRightMenuVisible" @close-menu="hideRightMenu" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import HeaderOnSlots from "../../../components/HeaderOnSlots";
import MainNavMenu from "../../../components/MainNavMenu";
import FormSelect from "../../../components/forms/FormSelect";
import NewFormCheckbox from "../../../components/forms/NewFormCheckbox";
import DeleteInfo from "../../../components/DeleteInfo";
import CircleLoader from "../../../components/CircleLoader";
import RegularButton from "../../../components/RegularButton";
import Icon from "../../../components/Icon";
import { saveAsFileWithType } from "../../../common";
import { formatMixins, nprogressMixin } from "../../../mixins";

import TableBreadcrumbs from "./TableBreadcrumbs";
import SearchForm from "./SearchForm";
import RightMenu from "./RightMenu";
import FormCheckboxMultiSelect from "./FormChekcboxMultiSelect";

export default {
  name: "AnaliticsBQC",
  components: {
    HeaderOnSlots,
    MainNavMenu,
    TableBreadcrumbs,
    SearchForm,
    FormSelect,
    RightMenu,
    DeleteInfo,
    CircleLoader,
    Icon,
    RegularButton,
    FormCheckboxMultiSelect,
    FormCheckbox: NewFormCheckbox
  },
  mixins: [formatMixins, nprogressMixin],
  data() {
    return {
      uploadData: false,
      isNavMenuVisible: false,
      isSearchFormVisible: false,
      isRightMenuVisible: false,
      navElements: [{ name: "ФККО", id: "root" }],
      columnsConfig: [
        {
          isActive: true,
          name: "Наименование",
          key: "name"
        },
        {
          isActive: true,
          name: "На начало года",
          key: "year_begin"
        },
        {
          isActive: true,
          name: "Образовано",
          key: "created"
        },
        {
          isActive: true,
          name: "Получено",
          key: "received"
        },
        {
          isActive: true,
          name: "Обработано",
          subname: "(в % от образованных)",
          key: "processed"
        },
        {
          isActive: true,
          name: "Утилизировано",
          subname: "(в % от образованных)",
          key: "recycled"
        },
        {
          isActive: true,
          name: "Обезврежено",
          subname: "(в % от образованных)",
          key: "neutralized"
        },
        {
          isActive: true,
          name: "Захоронено",
          subname: "(в % от образованных)",
          key: "disposed"
        },
        {
          isActive: true,
          name: "Хранение",
          key: "stored"
        },
        {
          isActive: true,
          name: "Передано",
          key: "sended"
        },
        {
          isActive: true,
          name: "На конец года",
          key: "year_end"
        }
      ],
      smartFilterSelected: {},
      ordering: {
        key: "",
        type: "NONE"
      },
      columnsForSmartFilter: {
        name: false,
        year_begin: false,
        created: false,
        received: false,
        recycled: false,
        neutralized: false,
        allocated: false,
        sended: false,
        year_end: false
      },
      periodFilter: `${new Date().getFullYear()}`,
      classFilter: [1, 2, 3, 4, 5],
      isActiveDeleting: false,
      deletingCanceled: false,
      showTableConfigs: false
    };
  },
  computed: {
    ...mapState(["isAuthorized"]),
    ...mapState("analiticsBQC", ["objectList", "classOptions"]),
    ...mapState({
      periodOptions: state => state.analiticsBQC.periodOptions()
    })
  },
  watch: {
    periodFilter(newValue) {
      this.uploadData = true;

      this.getObjectList({ params: { year: newValue, hazard_class: this.classFilter.join() } }).then(() => {
        this.uploadData = false;
      });
    }
  },
  mounted() {
    if (this.objectList.length === 0) {
      this.uploadData = true;

      this.getObjectList({ params: { year: this.periodFilter, hazard_class: this.classFilter.join() } }).then(() => {
        this.uploadData = false;
      });
    }
  },
  beforeDestroy() {
    this.setObjectList([]);
  },
  methods: {
    ...mapActions(["getSource"]),
    ...mapActions("analiticsBQC", ["getObjectList", "startEditing", "deleteObject", "exportObjects"]),
    ...mapMutations("analiticsBQC", ["removeObjectListItem", "setObjectList"]),
    onCloseNavMenu() {
      this.isNavMenuVisible = !this.isNavMenuVisible;
    },
    onSelectBreadcrumbItem(id) {
      if (id === "root") {
        this.navElements = [{ name: "ФККО", id: "root" }];
        this.uploadData = true;

        this.getObjectList({ params: { year: this.periodFilter, hazard_class: this.classFilter.join() } }).then(() => {
          this.uploadData = false;
        });
      } else {
        const index = this.navElements.findIndex(element => element.fkko_id === id);

        if (index > -1) {
          this.navElements = this.navElements.slice(0, index + 1);
          this.uploadData = true;

          this.getObjectList({ params: { year: this.periodFilter, hazard_class: this.classFilter.join(), parent_id: id } }).then(
            () => {
              this.uploadData = false;
            }
          );
        }
      }
    },
    onSelectTableItem(item) {
      if (item.has_children) {
        this.uploadData = true;
        this.navElements = [...this.navElements, item];

        this.getObjectList({
          params: { year: this.periodFilter, hazard_class: this.classFilter.join(), parent_id: item.fkko_id }
        }).then(() => {
          this.uploadData = false;
        });
      }
    },
    hideSearchForm() {
      this.isSearchFormVisible = false;
    },
    getSearchData(searchTerm) {
      return this.getSource({
        url: "/api/balance/simulated/search/",
        params: {
          search: searchTerm,
          year: this.periodFilter,
          hazard_class: this.classFilter.join()
        }
      }).then(res => {
        if (res.status === 200) {
          return res.data.results;
        }
        return [];
      });
    },
    onSelectSearchSuggestion(suggest) {
      this.uploadData = true;
      this.hideSearchForm();
      this.navElements = [
        { name: "ФККО", id: "root" },
        ...suggest.parents.map(item => ({ fkko_id: item.id, name: item.name, code: item.code }))
      ];

      this.getObjectList({
        params: { year: this.periodFilter, hazard_class: this.classFilter.join(), parent_id: suggest.parents.pop().id }
      }).then(() => {
        this.uploadData = false;

        this.$nextTick(() => {
          document.querySelectorAll(`.tr-elem-${suggest.fkko_id}`).forEach(element => element.classList.add("highligted"));
        });
      });
    },
    updateFilters(data) {
      if (data.fieldname === "period") {
        this.periodFilter = data.value;
      } else if (data.fieldname === "hazard_class") {
        this.classFilter = data.value;
      }
    },
    updateClassFilter(data) {
      if (data.changed) {
        this.uploadData = true;

        this.getObjectList({ params: { year: this.periodFilter, hazard_class: this.classFilter.join() } }).then(() => {
          this.uploadData = false;
        });
      }
    },
    onAddNewRecord() {
      this.startEditing({ year: this.periodFilter }).then(() => {
        this.isRightMenuVisible = true;
      });
    },
    showRightMenu() {
      this.isRightMenuVisible = true;
    },
    onEditItem(item) {
      const editObject = {
        ...item,
        fkko:
          item.fkko_id && item.code && item.name
            ? {
                id: item.fkko_id,
                code: item.code,
                name: item.name
              }
            : null
      };

      this.startEditing({ editObject, year: this.periodFilter }).then(() => {
        this.isRightMenuVisible = true;
      });
    },
    onCancelDeleting() {
      this.deletingCanceled = true;
      this.isActiveDeleting = false;
    },
    onDeleteItem(item) {
      this.isActiveDeleting = true;
      this.removeObjectListItem(item);

      setTimeout(() => {
        if (this.deletingCanceled) {
          this.deletingCanceled = false;
          return;
        }

        this.deleteObject({ fkko_id: item.fkko_id, year: this.periodFilter, hazard_class: this.classFilter.join() }).then(() => {
          this.reloadBQCList({ year: this.periodFilter, hazard_class: this.classFilter.join() });
        });
        this.isActiveDeleting = false;
      }, 4000);
    },
    closeDeleteInfo() {
      this.isActiveDeleting = false;
    },
    hideRightMenu() {
      this.isRightMenuVisible = false;
    },
    toggleTableConfig() {
      this.showTableConfigs = !this.showTableConfigs;
    },
    getAllActiveColumnsCount() {
      return this.columnsConfig.reduce((count, item) => {
        if (item.isActive) {
          count++;
        }
        return count;
      }, 0);
    },
    onSetChangeColumnsAll() {
      const activeColumnsCount = this.getAllActiveColumnsCount();
      if (activeColumnsCount === this.columnsConfig.length) {
        this.columnsConfig.map(s => {
          s.isActive = false;
          return s;
        });
      } else {
        this.columnsConfig.map(s => {
          s.isActive = true;
          return s;
        });
      }
    },
    onChangeActiveColumnConfig(column) {
      this.columnsConfig = this.columnsConfig.map(s => {
        if (s.key === column.key) {
          s.isActive = !s.isActive;
        }
        return s;
      });
    },
    onExportObjects() {
      this.uploadData = true;

      this.exportObjects(this.periodFilter).then(response => {
        this.uploadData = false;

        saveAsFileWithType(
          response.data,
          "Справочник_БКХ.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
    reloadBQCList() {
      this.uploadData = true;
      this.navElements = [{ name: "ФККО", id: "root" }];

      this.getObjectList({ params: { year: this.periodFilter, hazard_class: this.classFilter.join() } }).then(() => {
        this.uploadData = false;
      });
    },
    formatPercents(percent) {
      return Number.isInteger(percent) ? percent : percent.toFixed(2);
    }
  },
  provide: function() {
    return {
      hideSearchForm: this.hideSearchForm,
      reloadBQCList: this.reloadBQCList
    };
  }
};
</script>
